const STORAGE_KEY = "movie_app_favorites";

const safeParse = (value) => {
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const getFavorites = () => {
  return safeParse(localStorage.getItem(STORAGE_KEY));
};

export const isFavorite = (movieId) => {
  return getFavorites().some((movie) => movie.id === movieId);
};

export const saveFavorites = (favorites) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
  window.dispatchEvent(new Event("favorites-updated"));
};

export const toggleFavorite = (movie) => {
  const current = getFavorites();
  const exists = current.some((item) => item.id === movie.id);
  const next = exists
    ? current.filter((item) => item.id !== movie.id)
    : [...current, movie];
  saveFavorites(next);
  return !exists;
};
